module.exports = __webpack_public_path__ + "assets/images/template/project/animals/snake.png?v=036cce7e";